import { render, staticRenderFns } from "./PartnerCompanyInfo.vue?vue&type=template&id=71653354&scoped=true"
import script from "./PartnerCompanyInfo.vue?vue&type=script&lang=js"
export * from "./PartnerCompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerCompanyInfo.vue?vue&type=style&index=0&id=71653354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71653354",
  null
  
)

export default component.exports